import { Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { AuthGuard } from '../guards/auth-guard.service';
import { RoleGuard } from '../guards/role-guard.service';
import {DashboardChartComponent} from './dashboard_charts/DashboardCharts.component';
import { HomeComponent } from './home/home.component';
import { EventCalenderComponent } from './event_calender/event_calender.component';
import { ArticleComponent } from './article/article.component';
import { CreateArticleComponent } from './create-article/create-article.component';
import { ViewArticleComponent } from './view-article/view-article.component';
import { NewsletterListComponent } from './newsletter-list/newsletter-list.component';
import { NewsletterViewComponent } from './newsletter-view/newsletter-view.component';
import {DisclaimerComponent} from './disclaimer/disclaimer.component';
import {PrivacyComponent} from './privacy/privacy.component';
import { TemplateComponent } from './template/template.component';
import { TemplaterComponent } from './templater/templater.component';
import { SearchComponent } from './search/search.component';
import { SettingsComponent } from './settings/settings.component';
import { ManageArticleCategoryComponent } from './manage-article-category/manage-article-category.component';
import { ManageArticleTypeComponent } from './manage-article-type/manage-article-type.component';
import { ManageTemplateGroupComponent } from './manage-template-group/manage-template-group.component';
import { UserManagementComponent } from './user-management/user-management.component';
import { TemplateListComponent } from './template-list/template-list.component';
import {UserSetPermissionComponent} from './user-set-permission/user-set-permission.component';
import { NotificationListComponent } from './notification/notification.component';
import { TestComponent } from './test/test.component';
import { ManageUserGroupComponent } from './manage-user-group/manage-user-group.component';
import { AdminUserProfileComponent } from './admin-user-profile/admin-user-profile.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { ExternalUserProfileComponent } from './external-user-profile/external-user-profile.component';
import { AnalyticsComponent } from './analytics/analytics.component';
import { ManageCountryGroupComponent } from './manage-country-group/manage-country-group.component';
import { MasqueradeComponent } from './masquerade/masquerade.component';

export const dashboardRoutes: Routes = [
  {
    path: '',

    component: LayoutComponent,   
    
    canActivate: [AuthGuard],
    

    children: [

      
      { path: '', redirectTo: 'home', pathMatch: 'full' },

      {
        path:'analytics',component:AnalyticsComponent ,
        data: {'role':['view_analytics']},
        canActivate: [RoleGuard]
      },


      { 
        path:'permissions' , component:UserSetPermissionComponent,
        data: {'role':['manage_users']},
        canActivate: [RoleGuard]
    
       },   
         
       { 
        path:'notification' , component:NotificationListComponent,
        data: {'role':['']},
        canActivate: [RoleGuard]
    
       },   
         
    
      {
          path: 'newsletter', component: NewsletterListComponent,
          data: {'role':['']},
          canActivate: [RoleGuard]
                       
       
      },

      {

       path: 'newsletter/:id', component: NewsletterViewComponent,
       data: {'role':['']},
       canActivate: [RoleGuard]
                    
    
      },
      {
        path: 'newsletter/:id/view', component: NewsletterViewComponent,
        data: {'role':['']},
        canActivate: [RoleGuard]
                     
     
       },

      {
        path: 'newsletter/:id/edit', component: DashboardChartComponent,
        data: {'role':['manage_newsletter']},
        canActivate: [RoleGuard]
                     
     
       },

 
       {
        path: 'disclaimer', component: DisclaimerComponent,
        data: {'role':['']},
        canActivate: [RoleGuard]
                     
     
       },

       {
        path: 'privacy', component: PrivacyComponent,
        data: {'role':['']},
        canActivate: [RoleGuard]
                     
     
       },
       {
         path:'template', component:TemplateListComponent,
         data: {'role':['manage_templates']},
         canActivate: [RoleGuard]

       },

       {
         path:'template/create', component: TemplateComponent,
         data: {'role':['manage_templates']},
         canActivate: [RoleGuard]
       },

       {
        path: 'template/:id/edit', component: TemplateComponent,
        data: {'role':['manage_templates']},
        canActivate: [RoleGuard]
                    
        },
 
      //  {
      //   path:'templater', component: TemplaterComponent,
      //   data: {'role':['']},
      //   canActivate: [RoleGuard]
      // },


    {
    path: 'home', component: HomeComponent ,

    data: {'role':['']},   

    canActivate: [RoleGuard]

     },
     
     {
      path: 'calendar', component: EventCalenderComponent, 
      data: {'role':['create_newsletter']},
      canActivate: [RoleGuard]            
   
    },
    {
      path: 'article', component: ArticleComponent,   
      data: {'role':['']},
      canActivate: [RoleGuard]          
   
    },
    {
      path: 'article/create', component: CreateArticleComponent,   
      data: {'role':['create_article']},
      canActivate: [RoleGuard]          
   
    },

    {
      path: 'article/:id/edit', component: CreateArticleComponent,
      data: {'role':['create_article']},
      canActivate: [RoleGuard]
                   
     },
     
     {
      path: 'article/:id', component: ViewArticleComponent,
      data: {'role':['']},
      canActivate: [RoleGuard]
                   
     },

     {
      path: 'article/:id/view', component: ViewArticleComponent,
      data: {'role':['']},
      canActivate: [RoleGuard]
                   
     },
     {
      path: 'settings' , component: SettingsComponent,
      data: {'role':['manage_settings']},
      canActivate: [RoleGuard]
     },
     {
      path: 'settings/manage-article-category' , component: ManageArticleCategoryComponent,
      data: {'role':['manage_settings']},
      canActivate: [RoleGuard]
     },

     {
      path: 'settings/manage-article-type' , component: ManageArticleTypeComponent,
      data: {'role':['manage_settings']},
      canActivate: [RoleGuard]
     },
     {
      path: 'settings/manage-article-group' , component: ManageTemplateGroupComponent,
      data: {'role':['manage_settings']},
      canActivate: [RoleGuard]

     },
     {
      path: 'settings/manage-user-group' , component: ManageUserGroupComponent,
      data: {'role':['manage_settings']},
      canActivate: [RoleGuard]

     },
     {
      path: 'settings/manage-country-group' , component: ManageCountryGroupComponent,
      data: {'role':['manage_settings']},
      canActivate: [RoleGuard]

     },
     {
       path:'search', component:SearchComponent,
       data: {'role':['']},
       canActivate: [RoleGuard]
     },
     {
       path:'users',component:UserManagementComponent ,
       data: {'role':['manage_users']},
       canActivate: [RoleGuard]
     },
     {
      path:'user/profile',component:AdminUserProfileComponent ,
      data: {'role':['manage_users']},
      canActivate: [RoleGuard]
    },
    {
      path:'profile', component:UserProfileComponent,
      data: {'role':['']},
      canActivate: [RoleGuard]
    },
    {
      path:'masquerade', component:MasqueradeComponent,
      data: {'role':['']},
      canActivate: [RoleGuard]
    },
    {
      path:'exprofile', component:ExternalUserProfileComponent,
      data: {'role':['']},
      canActivate: [RoleGuard]
    },
    {
      path:'user/exprofile', component:ExternalUserProfileComponent,
      data: {'role':['manage_users']},
      canActivate: [RoleGuard]
    },

     {
      path:'test', component:TestComponent,
      data: {'role':['']},
      canActivate: [RoleGuard]
    },
   

     
	  
    ]
  }
];
